/* @flow */
import * as React from 'react';
import { translate } from 'react-i18next';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import { createModalSearchForm, makeFields } from '../searchForm/setupModalSearchForm';
import { ElectroSearchDropdown } from 'forms/components/inputs/ElectroSearchDropdown/ElectroSearchDropdown';
import type { TranslatorProps } from 'react-i18next';

type InjectedProps = TranslatorProps;
type ModalSearchProps = {
  url: string,
  type: string,
};

const types = {
  asset: {
    url: 'as-assets',
    apiType: 'AzureSearch',
    idKey: 'asset_id',
    renderKeys: ['asset_number', 'manufacturer_name', 'model', 'er_serial_number'],
    searchBy: [
      { key: 'asset_number', label: 'general:assets.labels.number', active: true },
      { key: 'er_serial_number', label: 'general:assets.labels.serial_number', active: false },
    ],
  },
  contract: {
    url: 'as-contracts',
    apiType: 'AzureSearch',
    idKey: 'contract_id',
    renderKeys: ['er_contract_number', 'er_order_type', 'er_status'],
    searchBy: [{ key: 'contract_number', label: 'general:contracts.labels.number', active: true }],
  },
  project: {
    url: 'projects',
    apiType: 'SQL',
    renderKeys: ['code', 'name', 'description'],
    searchBy: [{ key: 'code', label: 'general:projects.labels.code', active: true }],
  },
  costcenter: {
    url: 'cost-centres',
    apiType: 'SQL',
    renderKeys: ['code', 'name', 'description'],
    searchBy: [{ key: 'code', label: 'general:cost_centers.labels.code', active: true }],
  },
};

@translate()
@observer
export class ModalSearch extends ComponentWithInjectedProps<ModalSearchProps, {}, InjectedProps> {
  @observable localState = {};

  @computed get form(): Object {
    const { labels, fields, rules, extra } = makeFields(this.props.t);

    return createModalSearchForm(
      {
        labels,
        fields,
        rules,
        extra,
      },
      this.localState,
      this.props.t
    );
  }

  render() {
    const { form } = this;
    const { type } = this.props;
    const searchConfig = types[type];

    return (
      <React.Fragment>
        <ElectroSearchDropdown config={searchConfig} field={form.$('search.input')} />
      </React.Fragment>
    );
  }
}
